var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component filter-items"},_vm._l((_vm.items),function(item){return _c('FilterItem',{key:item,attrs:{"removeItem":function (){_vm.removeItem(item)}}},[_vm._v(_vm._s(item))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }